import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getSingleUserUseCase } from "@src/cloud-connect/user-manager/use-cases/get-single-user-use-case";
import { useI18N } from "@src/language/language-context";
import { updateShowOtaAcceptAndCreateBackupProcessModal } from "@src/reducers/your-reducer";
import { ActiveInstallationProcessPayload } from "@src/types/ota-update";

interface UseOtaBackupProcessAcceptAndCreateProps {
  activeInstallationData: ActiveInstallationProcessPayload | null;
}

export const useOtaBackupProcessAcceptAndCreate = ({
  activeInstallationData,
}: UseOtaBackupProcessAcceptAndCreateProps) => {
  const dispatch = useDispatch();
  const i18n = useI18N();
  const [approvalUserName, setApprovalUserName] = useState<string>("");

  useEffect(() => {
    async function fetchApproverName() {
      if (!activeInstallationData?.approval_user_id) {
        setApprovalUserName("");
        return;
      }

      const response = await getSingleUserUseCase(
        activeInstallationData.approval_user_id,
      );

      if (response.success && response.data?.display_name) {
        setApprovalUserName(response.data.display_name);
      } else {
        setApprovalUserName("");
      }
    }

    fetchApproverName();
  }, [activeInstallationData?.approval_user_id]);

  const texts = {
    title: i18n("modules.otaBackupProcessAcceptAndCreate.title"),
    descriptionTemplate: i18n(
      "modules.otaBackupProcessAcceptAndCreate.descriptionTemplate",
    ),
    acceptAndCreateBackupButtonText: i18n(
      "modules.otaBackupProcessAcceptAndCreate.acceptAndCreateBackupButtonText",
    ),
  };

  const description = texts.descriptionTemplate.replace(
    "{approver}",
    approvalUserName,
  );

  const handleAcceptAndCreateBackup = () => {
    dispatch(updateShowOtaAcceptAndCreateBackupProcessModal(true));
  };

  return {
    texts,
    description,
    handleAcceptAndCreateBackup,
  };
};
